import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { AlertTriangle, Clock, Info, Check } from "lucide-react";

const SEVERITY = {
  high: { color: "text-red-400 border-l-red-500", icon: AlertTriangle },
  medium: { color: "text-amber-400 border-l-amber-500", icon: Clock },
  low: { color: "text-muted-foreground border-l-zinc-500", icon: Info },
};

export default function Notifications() {
  const [items, setItems] = useState([]);

  useEffect(() => { load(); }, []);
  const load = () => api.get("/notifications").then(r => setItems(r.data));

  const markRead = async (id) => {
    try { await api.post(`/notifications/${id}/read`); load(); }
    catch (e) { /* eslint-disable-next-line no-console */ console.debug("[Notifications] markRead:", e); }
  };
  const unread = items.filter(i => !i.read);

  return (
    <div className="p-10 max-w-4xl" data-testid="notifications-page">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">Module 12</div>
          <h1 className="font-display font-bold text-5xl tracking-tight">Notifications</h1>
        </div>
        {unread.length > 0 && <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground">{unread.length} unread</div>}
      </div>

      {items.length === 0 ? (
        <div className="card-flat p-10 text-center text-muted-foreground" data-testid="notifications-list">All caught up. Nothing needs your attention.</div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map(n => {
            const meta = SEVERITY[n.severity] || SEVERITY.low;
            const Icon = meta.icon;
            return (
              <div key={n.id} className={`card-flat p-4 border-l-2 ${meta.color} ${n.read ? "opacity-50" : ""}`} data-testid={`notif-${n.id}`}>
                <div className="flex items-start gap-3">
                  <Icon size={16} className={meta.color.split(" ")[0]}/>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-base">{n.title}</div>
                    <div className="text-sm text-muted-foreground mt-1">{n.description}</div>
                    <div className="mt-2 flex items-center gap-3">
                      {n.action_url && <Link to={n.action_url} className="text-xs text-primary hover:underline">View →</Link>}
                      {!n.read && <button data-testid={`notif-read-${n.id}`} onClick={()=>markRead(n.id)} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1"><Check size={11}/> Mark read</button>}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
